<script setup lang="ts">
import { AppConfirmationModal } from '@libs/ui';

interface WhyWeSuggestModalEmits {
  (event: 'close'): void;
}

const emit = defineEmits<WhyWeSuggestModalEmits>();
</script>

<template>
  <AppConfirmationModal class="modal" @close="emit('close')">
    <template #title>
      <div class="title">
        {{ $t('planner.suggestion_modal.header') }}
      </div>
    </template>
    <template #content>
      <div class="content">
        <span>{{ $t('planner.suggestion_modal.paragraph_one') }}</span>
        <span>{{ $t('planner.suggestion_modal.paragraph_two') }}</span>
        <span>{{ $t('planner.suggestion_modal.paragraph_three') }}</span>
      </div>
    </template>
  </AppConfirmationModal>
</template>

<style scoped lang="scss">
.title {
  text-align: left;
}
.content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  text-align: left;
}
</style>
